module.exports = __webpack_public_path__ + "static/media/SUSD-logo.4302550f.png";